<!--When tenant isActive = false-->
<div *ngIf="isInactive" class="centered-container p-d-flex p-justify-center p-ai-center">
  <div class="card deactivated">
    <h1 class="title deactivated">Vaš nalog je deaktiviran zbog neplaćanja</h1>
    <p class="subtitle">
      Vaš pristup sistemu je trenutno ograničen zbog neizmirenih faktura
      evidentiranih u našem sistemu. Molimo vas da kontaktirate sektor finansija
      kako bismo odmah razrešili postojeće dugovanje.
    </p>
    <p class="subtitle">
      Ukoliko se naša evidencija razlikuje od vaše, unapred se izvinjavamo -
      javite nam kako bismo odmah izvršili proveru.
    </p>
    <div class="finance-box">
      <div class="finance-title">Kontakt finansija</div>
      <div class="finance-line">
        Telefon:
        <a href="tel:+381XXXXXXXXX">+381 64 277 46 61</a>
      </div>
      <div class="finance-line">
        E-mail:
        <a href="mailto:finansije@ekompanija.com">finansije@ekompanija.com</a>
      </div>
    </div>
    <kodit-placanja-tables [samoNeplaceni]="true" class="p-mt-4"></kodit-placanja-tables>
  </div>
</div>
<!--When subscriptions expired-->
<div *ngIf="!isInactive" class="centered-container p-d-flex p-justify-center p-ai-center">
  <div class="card subscription">
    <h1 class="title subscription">Vaš pristup je trenutno ograničen</h1>

    <p class="subtitle">
      Izgleda da nemate aktivan paket. Da biste nastavili da koristite sve
      funkcije eKompanije, potrebno je da odaberete novi plan.
    </p>

    <p class="subscription-text">
      Vaš prethodni period korišćenja je istekao. Bez aktivne pretplate ne
      možete pristupati funkcijama u aplikaciji.
    </p>

    <p class="subscription-text">
      Odaberite paket koji vam najviše odgovara i odmah nastavite sa radom — bez
      prekida i bez gubitka podataka.
    </p>

    <kodit-button
      btnLabel="Odaberite paket"
      class="p-mt-4"
      (btnClicked)="goToPaketi()"
    ></kodit-button>

    <div class="contact-section">
      <h2 class="contact-title">Treba vam pomoć oko odabira paketa?</h2>

      <p class="contact-text">
        Naš tim vam stoji na raspolaganju za sva pitanja u vezi pretplate,
        paketa i korišćenja sistema.
      </p>

      <div class="contact-grid">
        <div class="contact-block">
          <h3>Korisnička podrška</h3>
          <p class="contact-line">Telefon: <a href="tel:{{KORISNICKA_PODRSKA_MOBILE_HREF}}">{{KORISNICKA_PODRSKA_MOBILE}}</a></p>
          <p class="contact-line">
            E-mail:
            <a href="mailto:podrska@ekompanija.com">podrska@ekompanija.com</a>
          </p>
        </div>

        <div class="contact-block">
          <h3>Prodaja i ponude</h3>
          <p class="contact-line">
            Telefon:
            <a href="tel:+381 60 669 9361">+381 60 669 9361</a>
          </p>
          <p class="contact-line">
            E-mail:
            <a href="mailto:prodaja@ekompanija.com">finansije@ekompanija.com</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

